import {
    Step1FormConditionsProps,
    Step1FormOptionsProps,
    Step1FormProps,
} from '../types'
import React from 'react'
import { GenericDropdownItem } from '../../../../types'
import { PersonAuthorisationType } from '../../../providers/ActivationObjectProvider/types'

const useStep1FormConditions = (
    form: Step1FormProps['form'],
    options: Step1FormOptionsProps,
): Step1FormConditionsProps => {
    // zmena person type
    const { setValue } = form
    const personAuthorisationType = form.watch('personAuthorisationType')
    const personType = form.watch('personType')
    // nastaveni 1. polozky permissions, kdyz neni vybrana, nebo je zmenen seznam
    React.useEffect(() => {
        if (
            !personAuthorisationType ||
            options.permissions.findIndex(
                (perm: GenericDropdownItem<PersonAuthorisationType>) =>
                    perm.value === personAuthorisationType,
            ) === -1
        ) {
            setValue('personAuthorisationType', options.permissions[0].value)
        }
    }, [options.permissions, personAuthorisationType, personType, setValue])

    return {
        showUploadFile: personAuthorisationType === 'AuthRepresentative',
        showAnotherAuthorisationType: personAuthorisationType === 'Other',
    }
}

export default useStep1FormConditions
